import {request} from "./request";

// 获取会话存档配置
export function getSessionArchiveConfig() {
  return request({
      url: '/hkt/sessionarchiveconfig/get_session_archive_config',
      params: {

      }
  })
}
// 编辑会话存档配置
export function editSessionArchiveConfig(id, state, filesize) {
  return request({
      url: '/hkt/sessionarchiveconfig/edit_session_archive_config',
      params: {
        id,
        state,
        filesize
      }
  })
}

// 内部联系人列表
export function getQwUserList(userid) {
  return request({
      url: '/hkt/sessionarchive/get_qw_user_list',
      params: {
        userid
      }
  })
}

// 外部联系人列表
export function getQwExternalUserList(userid) {
  return request({
      url: '/hkt/sessionarchive/get_qw_external_user_list',
      params: {
        userid,
      }
  })
}

// 获取聊天记录
export function getSessionArchiveList(fromid, tolist_type, tolist, pagesize, page, text_content, type) {
  return request({
      url: '/hkt/sessionarchive/get_session_archive_list',
      params: {
        fromid,
        tolist_type,
        tolist,
        pagesize,
        page,
        text_content,
        type
      }
  })
}

// 获取群聊列表
export function getQwChatList(userid, pagesize, page, is_lock, chat_name) {
  return request({
      url: '/hkt/sessionarchive/get_qw_chat_list',
      params: {
        userid,
        pagesize,
        page,
        is_lock,
        chat_name
      }
  })
}

// 获取群聊列表
export function getDelContactsRecordList(type, pagesize, page, userid) {
  return request({
      url: '/hkt/sessionarchive/get_del_contacts_record_list',
      params: {
        type,
        pagesize,
        page,
        userid
      }
  })
}

// 删除会话存档
export function delSessionArchive(nodel_info, msgtime, pagesize) {
  return request({
      url: '/hkt/sessionarchive/del_session_archive',
      params: {
        nodel_info,
        msgtime,
        pagesize
      }
  })
}

// 删除会话存档
export function getDelSessionArchiveSpace(nodel_info, msgtime) {
  return request({
      url: '/hkt/sessionarchive/get_del_session_archive_space',
      params: {
        nodel_info,
        msgtime
      }
  })
}

// 获取会话存档配置公私密钥
export function createKey() {
  return request({
      url: '/hkt/sessionarchive/create_key',
      params: {
        
      }
  })
}

// 配置会话存档
export function editQwSessionArchiveConfig(data) {
  return request({
      url: '/hkt/sessionarchive/edit_qw_session_archive_config',
      method: 'post',
      headers: {
          'Content-Type': 'multipart/form-data'
      },
      data: data
  })
}